import { lazy } from 'react';

export const PlayerPhoneNumberForm = lazy(
  () => import('./PlayerPhoneNumberForm'),
);
